<template>
	<div class="body-container">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-portal-container container">
				<div class="site-container">
					<userHeader :subMenuIndex="2"></userHeader>
					<div class="comp-order-and-proofs-tab order-lists-component">
						<div class="comp-portal-pagination-container pagination-top hidden-sm hidden-xs cold-md-24">
							<div class="ng-untouched ng-valid ng-dirty">
								<div class="page-container">
									<el-pagination background layout="total, prev, pager, next, jumper" :total="totalNum"
										:current-page.sync="pageNum" :page-size="pageSize" @current-change="handleCurrentChange"
										@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
								</div>
							</div>
						</div>
						<div class="comp-order-lists-container row">
							<div class="comp-filter-container col-md-6 col-sm-24">
								<div class="comp-search-widget-container comp-order-search-container">
									<div class="search-widget site-form-group">
										<div class="ng-untouched ng-pristine ng-valid">
											<input v-model="searchNo" type="text" :placeholder="$t('order.searchorderorproject')" @keyup.enter="doSearch" maxlength="70" class="search-bar site-form-input form-control ng-untouched ng-pristine ng-valid"/>
											<div class="search-icon" @click="doSearch">
												<img src="../../assets/images/search.png" class="i-search-icon"/>
											</div>
										</div>
									</div>
								</div>
								<div>
									<ul class="nav portal-nav-stacked nav-stacked hidden-xs hidden-sm aria-parent-nav">
										<li :class="querySta == 0 ? 'active' : 'nav-item'" @click="changeSta(0)">
											<a class="on-hold">{{$t('order.ordersonhold')}}<!-- <small class="pull-right text-danger">1</small> --></a>
										</li>
										<li :class="querySta == 1 ? 'active' : 'nav-item'" @click="changeSta(1)">
											<a class="open-orders">{{$t('order.openorders')}}<!-- <small class="pull-right">1</small> --></a>
										</li>
										<li :class="querySta == 2 ? 'active' : 'nav-item'" @click="changeSta(2)">
											<a class="all-orders">{{$t('order.allorders')}}<!-- <small class="pull-right">1</small> --></a>
										</li>
										<!-- <li @click="changeDateCollapsed">
											<a class="collapsed"> 2025 <small class="pull-right"><img src="../../assets/images/arrow-down.png" class="list-icon fa fa-chevron-down dri-arrow-down down-icon"/></small></a>
											<ul class="nav nav-pills nav-stacked " :class="dateCollapsed ? '' : 'hide'">
												<li class="sub-filter-lists">
													<a class=""> Entire 2025 <small class="pull-right">1</small></a>
												</li>
												<li class="sub-filter-lists">
													<a class=""> September <small class="pull-right">1</small></a>
												</li>
											</ul>
										</li> -->
									</ul>
								</div>
								<div class="site-dropdown-group dropdown filter-mobile-responsive hidden-lg hidden-md" :class="isMobile && orderDropdown ? 'open' : ''">
									<button class="btn dropdown-toggle" @click="changeMobileOrderDropdown">
										<span class="dropdown-toggle-label" v-if="querySta == 0 ">{{$t('order.ordersonhold')}}</span>
										<span class="dropdown-toggle-label" v-if="querySta == 1 ">{{$t('order.openorders')}}</span>
										<span class="dropdown-toggle-label" v-if="querySta == 2 ">{{$t('order.allorders')}}</span>
										<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down down-icon"/>
									</button>
									<div class="dropdown-backdrop" v-if="isMobile && orderDropdown" @click="closeMobileOrderDropdown"></div>
									<ul class="dropdown-menu" v-if="isMobile && orderDropdown">
										<li>
											<a href="javascript:void()" @click="changeSta(0)" class="on-hold" :class="querySta == 0 ? 'selected' : ''">{{$t('order.ordersonhold')}}<!-- <small class="pull-right text-danger">1</small> --></a>
										</li>
										<li>
											<a href="javascript:void()" @click="changeSta(1)" class="open-orders" :class="querySta == 1 ? 'selected' : ''">{{$t('order.openorders')}}<!-- <small class="pull-right">1</small> --></a>
										</li>
										<li>
											<a href="javascript:void()" @click="changeSta(2)" class="all-orders" :class="querySta == 2 ? 'selected' : ''">{{$t('order.allorders')}}</a>
										</li>
										<!-- <li class="yearly-orders filter-list-group">
											<a class="dropdown-link-group">2025</a>
											<ul class="dropdown-menu sub-dropdown-menu" style="display: block;">
												<li>
													<a>整个2025年<small class="pull-right">1</small></a>
												</li>
												<li>
													<a>九月<small class="pull-right">1</small></a>
												</li>
											</ul>
										</li> -->
									</ul>
								</div>
							</div>
							<div class="comp-orders-lists-container col-md-18 col-sm-24">
								<div class="comp-orders-container panel panel-default" v-for="(item,index) in orderList" :key="index" >
									<div class="panel-heading">
										<div class="site-row">
											<div class="order-title-wrapper">
												<b class="order-title">{{$t('order.orderno')}} {{item.orderNo}}</b>
												<br>
												<small>{{$t('order.ordereddate')}} {{item.createTime}}</small>
												<span class="mobile-more-info-toggle" style="display: none;" @click.stop="changeItemCollapsed(index)">
													<img src="../../assets/images/arrow-down.png" class="fa fa-chevron-down dri-arrow-down down-icon"/>
												</span>
											</div>
											<div class="order-more-info-wrapper">
												<div class="order-info">
													<span class="more-info-text" @click.stop="changeItemCollapsed(index)">
														{{$t('order.moreinfos')}}
														<img src="../../assets/images/down.png" class="fa fa-chevron-down dri-arrow-down down-icon"/>
													</span>
													<span class="pull-right text-right order-total" v-if="lang == 'zh'">{{item.totalAmount}} 美元</span>
													<span class="pull-right text-right order-total" v-else>${{item.totalAmount}}</span>
												</div>
											</div>
										</div>
									</div>
									<div class="panel-body">
										<div class="order-details-header-wrapper" v-if="item.isExpand">
											<div class="site-row comp-more-info-content-container">
												<div class="more-info-divider">
													<div class="shipping-address-wrapper">
														<div><b>{{$t('cart.shippingaddress')}}</b></div>
														<div class="text-muted">
															<div v-if="item.sAddressbo">
																<div>{{item.sAddressbo.firstname}} {{item.sAddressbo.lastname}}</div>
																<div><small>{{item.sAddressbo.address}}</small></div>
																<div><small>{{item.sAddressbo.country}}, {{item.sAddressbo.province}} {{item.sAddressbo.city}}</small></div>
															</div>
														</div>
													</div>
													<div class="billing-address-wrapper">
														<div><b>{{$t('address.billingaddress')}}</b></div>
														<div class="text-muted">
															<div v-if="item.bAddressbo">
																<div>{{item.bAddressbo.firstname}} {{item.bAddressbo.lastname}}</div>
																<div><small>{{item.bAddressbo.address}}</small></div>
																<div><small>{{item.bAddressbo.country}}, {{item.bAddressbo.province}} {{item.bAddressbo.city}}</small></div>
															</div>
														</div>
														<br>
														<div><b>{{$t('user.paymentmethod')}}</b></div>
														<div class="text-muted">
															<div>
																<!-- <img src="../../assets/images/mastercard.svg"/> -->
																{{item.payName}}
															</div>
														</div>
													</div>
												</div>
												<br>
												<div class="more-info-divider order-summary">
													<div>
														<label>{{$t('common.quantity')}}</label>
														<label class="pull-right">{{item.qty}}</label>
													</div>
													<!-- <div class="sub-total">
														<label>{{$t('cart.subtotal')}}</label>
														<label class="pull-right" v-if="lang == 'zh'">{{item.totalAmount}}美元</label>
														<label class="pull-right" v-else>${{item.totalAmount}}</label>
													</div> -->
													<div>
														<label>{{$t('cart.tax')}}</label>
														<label class="pull-right" v-if="lang == 'zh'">{{item.tax}}美元</label>
														<label class="pull-right" v-else>${{item.tax}}</label>
													</div>
													<div class="shipping-handle">
														<label>{{$t('order.delivery')}}</label>
														<label class="pull-right" v-if="lang == 'zh'">{{item.deliveryfee ? item.deliveryfee : 0}}美元</label>
														<label class="pull-right" v-else>${{item.deliveryfee ? item.deliveryfee : 0}}</label>
													</div>
													<hr>
													<div class="clearfix">
														<label>{{$t('order.totalorderamount')}}</label>
														<label class="pull-right order-total" v-if="lang == 'zh'">{{item.totalAmount}}美元</label>
														<label class="pull-right order-total" v-else>${{item.totalAmount}}</label>
													</div>
												</div>
											</div>
										</div>
										<div class="comp-order-item-list-container">
											<div class="order-item-container" v-for="(products,pindex) in item.busOrderItemList">
												<div class="order-item-thumbnail-container">
													<div class="on-hold-thumb text-center text-danger">
														<!-- <img src="../../assets/images/danger.png" class="danger-icon"/>
														<br>
														<small>{{$t('order.holdon')}}</small>
														<br>
														<small>{{$t('order.waitingforfile')}}</small> -->
														<div class="image-stack" :class="products.filelist.length > 1 ? '' : 'image-stack-full'" v-if="products.filelist">
															<div class="image-card" v-for="imgs in products.filelist">
																 <el-image style="width: 100%; height: 100%" :src="imgs" :preview-src-list="products.filelist"></el-image>
															</div>
														</div>
														<el-image style="width: 100%; height: 100%" v-else>
														    <div slot="error" class="image-slot">
																<i class="el-icon-picture-outline"></i>
														    </div>
														</el-image>
													</div>
												</div>
												<div class="order-item-details" @click="openPage('orderDetail?no='+item.id+'&oid='+products.id)">
													<div class="order-item-size">{{products.productName}}</div>
													<div class="order-item-project-name">{{products.productAttributeVOList}}</div>
												</div>
												<div class="order-item-status" @click="openPage('orderDetail?no='+item.id+'&oid='+products.id)">
													<div class="comp-order-item-status-tracker-container icon-group no-padding">
														<ul class="status-tracker-list-container list-inline status-icons text-center">
															<li class="status-tracker-list list-group">
																<div :class="products.sta >= 0 ? 'icon-on-hold' : 'icon-queued'">
																	<img src="../../assets/images/red-file.png" class="file-icon" v-if="products.sta >= 0"/>
																	<img src="../../assets/images/grey-file.png" class="file-icon" v-else/>
																	<br>
																	<label class="status-icon-label">{{$t('order.filereview')}}</label>
																</div>
															</li>
															<li class="status-tracker-list list-group">
																<div :class="products.sta >= 1 ? 'icon-on-hold' : 'icon-queued'">
																	<img src="../../assets/images/red-ys.png" class="file-icon" v-if="products.sta >= 1"/>
																	<img src="../../assets/images/grey-ys.png" class="file-icon" v-else />
																	<br>
																	<label class="status-icon-label">{{$t('order.printing')}}</label>
																</div>
															</li>
															<li class="status-tracker-list list-group">
																<div :class="products.sta >= 2 ? 'icon-on-hold' : 'icon-queued'">
																	<img src="../../assets/images/red-ship.png" class="file-icon" v-if="products.sta >= 2"/>
																	<img src="../../assets/images/grey-ship.png" class="file-icon" v-else/>
																	<br>
																	<label class="status-icon-label">{{$t('order.shipping')}}</label>
																</div>
															</li>
														</ul>
													</div>
												</div>
												<div class="comp-order-alert-container for-action-alert-message" @click="openPage('orderDetail?no='+item.id+'&oid='+products.id)">
													<div class="order-alert">
														<label class="text-danger order-alert-label">
															<strong class="alert-strong-label">{{products.makelStaName}}</strong>
															<!-- <span class="alert-label">需要您采取行动。</span> -->
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pagination-bottom comp-portal-pagination-container">
							<div class="ng-untouched ng-valid ng-dirty">
								<div class="page-container">
									<el-pagination background layout="total, prev, pager, next, jumper" :total="totalNum"
										:current-page.sync="pageNum" :page-size="pageSize" @current-change="handleCurrentChange"
										@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import userHeader from '../../components/userHeader.vue'
	import {queryOrderList} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			userHeader
		},
		data() {
			return {
				isMobile:false,
				dateCollapsed:false,
				itemCollapsed:false,
				orderDropdown:false,
				pageNum:1,
				pageSize:10,
				totalNum:0,
				orderList:[],
				lang:'',
				querySta:2,//=0暂停 1 未结算 2所有
				searchNo:''
			};
		},
		mounted() {
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			this.init()
		},
		methods: {
			init(){
				var that = this;
				let params = {
					pageSize:this.pageSize,
					pageNum:this.pageNum,
					sta:this.querySta,
					queryparam:this.searchNo
				}
				queryOrderList(params).then(res => {
					if (res.code == 200) {
						that.orderList = res.data.list
						if(that.orderList.length > 0){
							that.orderList.forEach((item) => {
								that.$set(item,'isExpand',false)
							})
						}
						that.totalNum = res.data.total
					}
				})
			},
			changeDateCollapsed(){
				this.dateCollapsed = !this.dateCollapsed
			},
			changeItemCollapsed(index){
				this.orderList[index].isExpand = !this.orderList[index].isExpand
				//this.itemCollapsed = !this.itemCollapsed
			},
			changeMobileOrderDropdown(){
				this.orderDropdown = !this.orderDropdown
			},
			closeMobileOrderDropdown(){
				this.orderDropdown = false
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			doSearch(){
				this.pageSize = 1
				this.init()
			},
			changeSta(e){
				this.querySta = e
				this.searchNo = ''
				this.pageSize = 1
				this.closeMobileOrderDropdown()
				this.init()
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/order.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>